<table id="{{tableId}}" mat-table [dataSource]="jobs | async" class="mat-elevation-z0 jobs-list" multiTemplateDataRows
    matSort (matSortChange)="sortData($event)">
    <ng-container *ngIf="showSelectedColumn" matColumnDef="selected">
        <th mat-header-cell *matHeaderCellDef [ngClass]="'jobs-column-selected'">
            <mat-checkbox (change)="setSelectedAllJobs($event)" #selectAllCheckbox></mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let job" class="selected-column-cell">
            <mat-checkbox [(ngModel)]="job.isSelected"></mat-checkbox>
        </td>
    </ng-container>

    <ng-container matColumnDef="{{column.property}}" *ngFor="let column of jobColumns">
        <th mat-header-cell *matHeaderCellDef [ngClass]="getHeaderClass(column)" mat-sort-header="{{column.property}}"
            [disabled]="!column.sortable">
            <div style="width: 100%;">
                <div>{{column.title || column.getTitle()}}</div>
                <div *ngIf="column.filter">
                    <mat-form-field *ngIf="column.filterType=='text'" subscriptSizing="dynamic"
                        class="filter-header-input">
                        <input matInput type="text" placeholder="{{column.title || column.getTitle()}}"
                            (click)="filterClick($event)" [(ngModel)]="filter[column.filter]"
                            (valueChange)="filterChange()" />
                    </mat-form-field>
                    <mat-form-field *ngIf="column.filterType=='date'" subscriptSizing="dynamic"
                        class="filter-header-input">
                        <input matInput type="date" placeholder="{{column.title || column.getTitle()}}"
                            (click)="filterClick($event)" [(ngModel)]="filter[column.filter]" (change)="filterChange()"
                            class="date-input" />
                    </mat-form-field>
                    <mat-form-field *ngIf="column.filterType=='jobType'" subscriptSizing="dynamic"
                        class="filter-header-input">
                        <mat-select multiple placeholder="Job type" [(value)]="filter[column.filter]"
                            class="filter-header-select" (selectionChange)="filterChange()"
                            (click)="filterClick($event)" [panelWidth]="'600px'">
                            <mat-option *ngFor="let jobType of jobsList" [value]="jobType" class="filter-header-options"
                                matTooltip="{{getTaskDescriptionByTaskType(jobType)}}"> {{getPrettyTaskType(jobType)}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field *ngIf="column.filterType=='statuses'" subscriptSizing="dynamic"
                        class="filter-header-input">
                        <mat-select multiple placeholder="Status" [(value)]="filter[column.filter]"
                            class="filter-header-select" (selectionChange)="filterChange()"
                            (click)="filterClick($event)" [panelWidth]="'job-status-filter-select'">
                            <mat-option *ngFor="let taskStatus of tasksStatuses" [value]="taskStatus"
                                class="filter-header-options">
                                {{getPrettyTaskStatus2(taskStatus)}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field *ngIf="column.filterType=='state'" subscriptSizing="dynamic"
                        class="filter-header-input">
                        <mat-select multiple placeholder="State" [(value)]="filter[column.filter]"
                            class="filter-header-select" (selectionChange)="filterChange()"
                            (click)="filterClick($event)" [panelWidth]="'job-state-filter-select'">
                            <mat-option *ngFor="let instance of instances" [value]="instance.State?.toLowerCase()"
                                class="filter-header-options">
                                {{instance.Name}} - {{instance.State?.toLowerCase()}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </th>
        <td mat-cell *matCellDef="let job" (click)="showAttachnments(job)" [ngClass]="getCellClass(column)"
            title="{{column.showTitle?job[column.property]:undefined}}">
            {{job[column.property]}}
        </td>
    </ng-container>

    <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef [ngClass]="'jobs-column-actions'">Actions</th>
        <td mat-cell *matCellDef="let job" class="actions-container" (click)="showAttachnments(job)">
            <app-active-job-actions *ngIf="!job.isArchived" [job]="job"></app-active-job-actions>
            <app-archived-job-actions *ngIf="job.isArchived" [job]="job"></app-archived-job-actions>
        </td>
    </ng-container>

    <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let job" [attr.colspan]="jobColumnsToDisplay.length">
            <div class="job-attachments-detail" [ngClass]="job == expandedElement ? 'expanded' : 'collapsed'">
                <mat-table [dataSource]="job.attachments" class="mat-elevation-z16" style="width: 100%">
                    <ng-container matColumnDef="{{column.property}}" *ngFor="let column of attachmentsColumns">
                        <mat-header-cell *matHeaderCellDef> {{column.title}} </mat-header-cell>
                        <mat-cell *matCellDef="let attachment"> {{attachment[column.property]}} </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="Actions">
                        <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
                        <mat-cell *matCellDef="let attachment" class="actions-container">
                            <button mat-icon-button fileSaver [method]="'GET'" [fileName]="attachment.FileName"
                                [url]="attachment.URL" [header]="{'Access-Control-Allow-Origin':'*'}">
                                <mat-icon matTooltip="Download">save_alt</mat-icon>
                            </button>
                        </mat-cell>
                    </ng-container>
                    <mat-header-row *matHeaderRowDef="attachmentsColumnsToDisplay"></mat-header-row>
                    <mat-row *matRowDef="let attachment; columns: attachmentsColumnsToDisplay"></mat-row>
                </mat-table>
            </div>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="jobColumnsToDisplay; sticky: true"></tr>
    <tr mat-row *matRowDef="let job; columns: jobColumnsToDisplay;" class="job-element-row"
        [class.job-expanded-row]="expandedElement === job"></tr>
    <tr mat-row *matRowDef="let job; columns: ['expandedDetail']" class="attachments-detail-row"></tr>
</table>

<app-spinner *ngIf="showSpinner"></app-spinner>

<button mat-fab class="add-button" (click)="newTaskDialog()" *ngIf="!hideAddButton">
    <mat-icon aria-label="Add Job">add</mat-icon>
</button>